<template>
  <div style="background: #faf9de; height: 100vh; overflow: hidden">
    <el-container style="height: 100vh">
      <!-- 侧边栏 -->
      <el-aside
        style="
          width: 150px;
          height: calc(100vh - 20px);
          background: #ffffff;
          border-radius: 15px;
          margin: 10px;
          padding: 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          flex-shrink: 0;
        "
      >
        <div
          id="banner"
          style="
            height: 60px;
            line-height: 60px;
            background-color: #ffd700;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            border-radius: 15px 15px 0 0;
          "
        >
          <img
            src="/favicon.ico"
            alt="捏词Logo"
            style="
              width: 28px;
              height: 28px;
              border-radius: 50%;
              background: white;
              padding: 2px;
            "
          />
          <div style="font-weight: bold; font-size: 18px">捏词</div>
        </div>
        <!--$route.path 是当前路由  router 路由生效 -->
        <el-menu
          id="menu"
          router
          style="
            height: calc(100vh - 100px);
            width: 150px;
            padding: 10px;
            overflow-y: auto;
          "
          default-active="/testTable"
          text-color="#000"
          active-text-color="#000"
        >
          <el-menu-item
            index="/mainTable"
            style="font-size: large"
            class="menu-item"
          >
            运营数据
          </el-menu-item>
          <el-menu-item
            index="/testTable"
            style="font-size: large"
            class="menu-item"
          >
            真题汇总
          </el-menu-item>

          <el-menu-item
            index="/feedbackTable"
            style="font-size: large"
            class="menu-item"
          >
            工单处理
          </el-menu-item>
          <el-menu-item
            index="/wordTable"
            style="font-size: large"
            class="menu-item"
          >
            单词对话管理
          </el-menu-item>
          <el-menu-item
            index="/wordDetailTable"
            style="font-size: large"
            class="menu-item"
          >
            单词管理
          </el-menu-item>
          <el-menu-item
            index="/roleTable"
            style="font-size: large"
            class="menu-item"
          >
            角色卡管理
          </el-menu-item>
          <el-menu-item
            index="/promotionTable"
            style="font-size: large"
            class="menu-item"
          >
            推广管理
          </el-menu-item>
          <el-menu-item
            index="/reviewRewardTable"
            style="font-size: large"
            class="menu-item"
          >
            评论奖励
          </el-menu-item>
          <el-menu-item
            index="/systemManage"
            style="font-size: large"
            class="menu-item"
          >
            系统管理
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-container
        style="height: 100vh; display: flex; flex-direction: column"
      >
        <!-- 头部区域 -->
        <el-header
          style="
            background: #faf9de;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            height: 60px;
            flex-shrink: 0;
          "
        >
          <div style="font-size: 24px; font-weight: bold; color: #000">
            Hi, {{ adminName }}
          </div>
          <div style="display: flex; align-items: center">
            <div
              style="
                background: #ffd700;
                color: #000;
                padding: 8px 16px;
                border-radius: 20px;
                font-weight: bold;
              "
            >
              管理员
            </div>
          </div>
        </el-header>
        <!-- 主题区域 -->
        <el-main
          style="
            background: #faf9de;
            padding: 20px;
            flex: 1;
            overflow: hidden;
            height: 0;
          "
        >
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      adminName: "管理员", // 默认值
    };
  },
  mounted() {
    // 从本地存储获取用户信息
    this.getAdminInfo();
  },
  methods: {
    getAdminInfo() {
      // 从localStorage获取用户信息
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        try {
          const user = JSON.parse(userInfo);
          this.adminName =
            user.adminName || user.username || user.name || "管理员";
        } catch (e) {
          console.error("解析用户信息失败:", e);
          this.adminName = "管理员";
        }
      } else {
        // 如果本地存储没有，可以尝试从其他地方获取
        // 比如从token中解析，或者调用API获取
        this.adminName = "管理员";
      }
    },
  },
};
</script>

<style>
/* 全局样式 - 禁止整个页面滚动 */
body,
html {
  overflow: hidden !important;
  height: 100vh !important;
}

/* 确保页面根容器不滚动 */
.el-container {
  overflow: hidden !important;
}

/* 最外层容器样式 */
div[style*="background: #faf9de"] {
  overflow: hidden !important;
  height: 100vh !important;
}

#banner {
  font-family: "ka1";
  text-align: center;
  transition: all 0.3s;
  font-size: 18px;
  background-color: #ffd700 !important;
  color: #000 !important;
  font-weight: bold;
}

#menu {
  font-family: "fangzheng";
  text-align: center;
  background-color: #ffffff !important;
  border: none !important;
  border-radius: 0 0 15px 15px;
}

/* 菜单项基础样式 */
.el-menu-item {
  margin: 5px 0 !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

/* 悬停效果 */
.el-menu-item:hover {
  background-color: #fff1c1 !important;
  color: #000 !important;
  font-weight: bold !important;
}

/* 选中状态样式 */
.el-menu-item.is-active {
  background-color: #ffd700 !important;
  color: #000 !important;
  font-weight: bold !important;
  /* border: 2px solid #ffd700 !important; */
  border-radius: 8px !important;
}

/* 头部样式优化 */
.el-header {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 60px !important;
  flex-shrink: 0 !important;
}

/* 主体区域样式 */
.el-main {
  background: #faf9de !important;
  height: 0 !important;
  flex: 1 !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 10px !important;
}

/* 容器样式 */
.el-container {
  background: #faf9de;
  height: 100vh !important;
  overflow: hidden !important;
}

/* 右侧容器样式 */
.el-container > .el-container {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  overflow: hidden !important;
}

/* 滚动条样式已移除 - el-main不再滚动 */

/* 侧边栏样式 */
.el-aside {
  background: #ffffff !important;
  border-radius: 15px !important;
  margin: 10px 10px 20px 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  height: calc(100vh - 20px) !important;
  flex-shrink: 0 !important;
}

/* 侧边栏菜单滚动条样式 */
#menu::-webkit-scrollbar {
  width: 6px;
}

#menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

#menu::-webkit-scrollbar-thumb {
  background: rgba(255, 215, 0, 0.3);
  border-radius: 10px;
}

#menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 215, 0, 0.5);
}

/* 响应式样式 */
@media (max-width: 768px) {
  .el-aside {
    width: 120px !important;
  }

  #menu {
    width: 120px !important;
  }

  /* 移动设备隐藏滚动条 */
  #menu::-webkit-scrollbar {
    display: none;
  }
}
</style>
